var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          staticClass: "filter-item",
          attrs: { type: "primary" },
          on: { click: _vm.addFun }
        },
        [_vm._v("新增")]
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            stripe: "",
            data: _vm.tableData,
            "cell-style": _vm.isCenter,
            "header-cell-style": _vm.isCenter,
            "highlight-current-row": true
          },
          on: { "row-click": _vm.handleRowClick }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(column, index) {
            return [
              column.isShow
                ? _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      formatter: column.formatter,
                      width: column.width,
                      sortable: column.sortable
                    }
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "80", prop: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", title: "删除", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.delMenu(scope.$index, scope.row.id)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          attrs: {
            "label-width": "180px",
            size: "small",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticStyle: { width: "355px" },
              attrs: { label: "完成任务后是否停留：" }
            },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: "0" },
                  model: {
                    value: _vm.addData.isStay,
                    callback: function($$v) {
                      _vm.$set(_vm.addData, "isStay", $$v)
                    },
                    expression: "addData.isStay"
                  }
                },
                [_vm._v("否")]
              ),
              _vm._v(" "),
              _c(
                "el-radio",
                {
                  attrs: { label: "1" },
                  model: {
                    value: _vm.addData.isStay,
                    callback: function($$v) {
                      _vm.$set(_vm.addData, "isStay", $$v)
                    },
                    expression: "addData.isStay"
                  }
                },
                [_vm._v("是")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.addData.isStay === "1"
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: "停留时长：",
                    prop: "skillId",
                    "label-width": "100"
                  }
                },
                [
                  _c("el-time-picker", {
                    attrs: {
                      "value-format": "HH:mm:ss",
                      placeholder: "请输入停留时长"
                    },
                    model: {
                      value: _vm.addData.stayTime,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "stayTime", $$v)
                      },
                      expression: "addData.stayTime"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            modal: false,
            title: _vm.title,
            width: "600px",
            visible: _vm.addPos,
            "before-close": _vm.closeDiglog,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.addPos = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addPos",
              attrs: {
                model: _vm.addData,
                rules: _vm.rules,
                "label-width": "160px",
                size: "small"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "355px" },
                  attrs: { label: "技能：", prop: "skillId" }
                },
                [
                  _c("v-selectpage", {
                    staticClass: "form-control",
                    attrs: {
                      data: _vm.skillListData,
                      "key-field": "id",
                      "show-field": "name"
                    },
                    model: {
                      value: _vm.addData.skillId,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "skillId", $$v)
                      },
                      expression: "addData.skillId"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: " " } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("提交")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.onCencal } }, [
                    _vm._v("取消")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }